import {createRoot} from 'react-dom/client';

import {
    Provider
} from 'react-redux';

import {
    configureStore
} from '@js/stores';

import BlogShow from '@js/components/blogs/blog';

require('@js/common');

const root = createRoot(document.getElementById('blog-component'));
root.render(
    <Provider store={configureStore}>
        <BlogShow userId={1}/>
    </Provider>
);
